import { createDropdownOption } from 'utils/helpers';
import { UNIT_MODIFIER_VALUES } from 'utils/relativeDateTime';

export const EXACTLY = createDropdownOption(UNIT_MODIFIER_VALUES.exactly, 'Exactly');
export const NOW = createDropdownOption(UNIT_MODIFIER_VALUES.now, 'Now');
export const STARTOF = createDropdownOption(UNIT_MODIFIER_VALUES.start, 'Start Of');
